module.exports = __webpack_public_path__ + "static/media/delivery.b95047ea.png";